import { createBrowserRouter } from "react-router";

import ChatbotAppChat from "./pages/chat/ChatbotAppChat";
import NotFound from "./pages/errors/NotFound";

const router = createBrowserRouter([
	{
		path: "/:id",
		element: <ChatbotAppChat />,
	},
	{
		path: "*",
		element: <NotFound />,
	},
]);

export default router;
